import * as React from 'react'
import { useContext } from 'react'
import { Result } from 'antd'
import { InfoCxt } from '../../App'

interface RequireRoleProps {
  allow: string[]
  children: React.ReactNode
}

export const RequireRole: React.FC<RequireRoleProps> = ({ allow, children }) => {
  const { role } = useContext(InfoCxt)

  if (role && !allow.includes(role)) {
    return (
      <Result
        status='403'
        title='403'
        subTitle="Sorry, you don't have permission to access this page."
      />
    )
  }

  return <>{children}</>
}
